import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import { selectBlogRequestsQueryItems } from '../../../../../../redux/blog-requests/selector';
import { blogRequests } from '../../../../../../redux/blog-requests/action';
import PageLoader from '../../../../../../components/PageLoader';
import { selectInfluencersQueryItems } from '../../../../../../redux/influencers/selector';
import { influencers } from '../../../../../../redux/influencers/action';
import BlogRequestComponent from '../components/blog-request.component';
import { selectListItems } from '../../../../../../redux/library/selector';


const ManagementBlogRequest = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector(selectBlogRequestsQueryItems)
  const influencersItems = useSelector(selectInfluencersQueryItems)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const libraryData = useSelector(selectListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    selectedBlog,
    setSelectedBlog
  ] = useState<any>({})

  const fetchAllTaskById = () => {
    dispatch(blogRequests.query({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/crm/tasks/query`, entity: 'blogRequests', jsonData: {

        Records: [
          {


            "Id": parmas?.id



          }
        ]

      }
    })).then(() => {
      setIsQuery(true)
    })




  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedBlog({ ...selectedBlog, [field]: event });
  }

  useEffect(
    () => {
      dispatch(influencers.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/rms/influencers/list`, entity: 'influencers', jsonData: {
        }
      })).then(() => {
        if (parmas?.id > 0) {
          fetchAllTaskById()
          setIsLoading(false)

        }
        else {
          setIsLoading(false)

        }
      })
    },
    []
  )
  useEffect(
    () => {

      if (isQuery) {
        setSelectedBlog(queryItems?.result?.items)
      }
    },
    [isQuery]
  )

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
      dispatch(blogRequests.update({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/crm/tasks`, entity: 'blogRequests', jsonData: {

          Records: [
            {


              ...selectedBlog



            }

          ]

        }
      })).then(() => {
        back()
      })

    } else {
      dispatch(blogRequests.create({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/crm/tasks`, entity: 'blogRequests', jsonData: {

          Records: [
            {


              ...selectedBlog



            }
          ]

        }
      })).then(() => {
        back()
      })
    }

  }

  const back = () => {
    navigate('/management/cms/blog/blog-requests')
  }
  const handleBlogPost = () => {
    navigate('/management/cms/blog/blog-posts/0')
  }
  return (
    <>
      {isLoading ? <PageLoader /> :
        <BlogRequestComponent
          handleInnerFormChange={handleInnerFormChange}
          taskStatus={libraryData?.result?.TaskStatus}
          handleFormSubmit={handleFormSubmit}
          back={back}
          selectedBlog={selectedBlog}
          handleBlogPost={handleBlogPost}
          influencer={influencersItems?.result?.items}
        />}
    </>
  )

}

export default ManagementBlogRequest;
